import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navbar, NavbarUser, Footer } from '../../containers';
import './myevents.css';
import api from "../../api/axios";
import { useTranslation } from 'react-i18next';


const MyEvents = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { eventData } = location.state || {};
    const [bookedEvents, setBookedEvents] = useState([]);
    const [pictureSrc, setPictureSrc] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(true);

    // Footer berechnen
    const footerRef = useRef(null);
    const [footerHeight, setFooterHeight] = useState(0);
    // Navbar berechnen
    const [navbarHeight, setNavbarHeight] = useState(0);

    useEffect(() => {
        if (footerRef.current) {
            setFooterHeight(footerRef.current.clientHeight);
        }

        const navbarElement = document.querySelector(".navbarHomepage");
        if (navbarElement) {
            setNavbarHeight(navbarElement.offsetHeight);
        }

        const fetchPicture = async () => {
            try {
                const pictureId = 22;
                const res = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(res.data.picture);
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
        fetchBookedEvents();

        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const fetchBookedEvents = async () => {
        try {
            const res = await api.post("/user/bookedevents");

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const twoDaysAgo = new Date(today);
            twoDaysAgo.setDate(today.getDate() - 2);

            const filtered = res.data.filter(event => {
                const eventDate = new Date(event.date);
                eventDate.setHours(0, 0, 0, 0);
                return eventDate >= twoDaysAgo;
            });

            setBookedEvents(filtered);
        } catch (error) {
            if (error.response?.status === 401) {
                setIsAuthenticated(false);
            } else {
                console.error("Error fetching booked events:", error);
            }
        }
    };

    const formatEventDate = (dateString) => {
        const options = {
            timeZone: 'Europe/Berlin', // Change to your desired time zone
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        const dateTimeFormat = new Intl.DateTimeFormat('de-DE', options);
        const formattedDate = dateTimeFormat.format(new Date(dateString));
        return formattedDate; // Format as DD.MM.YYYY
    };

    const cancelEvent = async (eventid) => {
        try {
            await api.post("/user/cancelevent", { eventid });
            fetchBookedEvents();
        } catch (error) {
            console.error("Error cancelling event:", error);
        }
    };

    const backtoprofile = () => {
        navigate('/profile');
    };

    const goToStore = () => {
        navigate('/eventsstore');
    };

    const backToHomepage = () => {
        navigate('/');
    };

    const navigateBookedEventDetails = (event) => {
        if (event.eventtype.toLowerCase() === "pub crawl") {
            navigate("/profile/pubcrawl", {
                state: {
                    eventid: event.eventid
                }
            });
        } else {
            navigate("/profile/bookedevents", {
                state: {
                    eventid: event.eventid
                }
            });
        }
    };

    if (!isAuthenticated) {
        return (
            <div className="wrapper-myevents" style={{
                backgroundImage: pictureSrc ? `url(${pictureSrc})` : 'none'
            }}>
                <Navbar />
                <div className='myevents-site' style={{ minHeight: `calc(100vh - ${footerHeight}px)` }}>
                    <div className="myevents-content-parent" style={{ marginTop: `${navbarHeight + 1}px` }}>
                        <button onClick={() => backToHomepage()}>{t('EventBackToHomepage')}</button>
                        <p>{t('NoEventDataLoggedIn')}</p>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className='wrapper-myevents' style={{
            backgroundImage: pictureSrc ? `url(${pictureSrc})` : 'none'
        }}>
            <>
                <NavbarUser />
                <div className='myevents-site' style={{ minHeight: `calc(100vh - ${footerHeight}px)` }}>
                    <div className="myevents-content-parent" style={{ marginTop: `${navbarHeight + 1}px` }}>
                        <button onClick={() => backtoprofile()}>{t('EventBackToProfile')}</button>
                        {bookedEvents.length > 0 ? (
                            bookedEvents.map((event) => (
                                <div className="myevents-content-child" key={event.eventid}>
                                    <h2>{t('WelcomeEvent')}{event.eventname}</h2>
                                    <img
                                        src={`data:image/png;base64,${event.lokalpic}`}
                                        alt={event.lokal} />
                                    <p><strong>{t('WhatsTheEvent')}</strong> {event.description}</p>
                                    <p><strong>{t('EventType')}</strong> {event.eventname}</p>
                                    <p><strong>{t('EventLokal')}</strong> {event.lokal}</p>
                                    <p><strong>{t('EventAddress')}</strong> {event.address}</p>
                                    <p><strong>{t('EventDate')}</strong> {formatEventDate(event.date)}</p>
                                    <button className="cancel-event" onClick={() => cancelEvent(event.eventid)}>{t('CancelEvent')}</button>
                                    <button className="details-event" onClick={() => navigateBookedEventDetails(event)}>{t('EventDetails')}</button>
                                </div>
                            ))
                        ) : (
                            <div className="myevents-content-parent">
                                <p>{t('NoEventData')}</p>
                                <button onClick={() => goToStore()}>{t('EventGoToStore')}</button>
                            </div>
                        )}
                    </div>
                </div>
            </>
            <Footer></Footer>
        </div>
    )
}

export default MyEvents